import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Box, Typography, Paper } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import './About.css'
import { Helmet } from 'react-helmet';

const About = () => {
    return (
        <Container id='courses' fluid elevation={3} className="p-4" style={{fontFamily: 'Roboto Slab, serif' }}>
             <Helmet>
        <title>About Holy Institute</title>
        <meta name="description" content="Learn more about Holy Institute. We offer comprehensive German language courses with flexible timings and affordable fees." />
        <meta name="keywords" content="About Holy Institute, German language courses, flexible timings, affordable fees" />
      </Helmet>
            <Box component={Paper} elevation={3} className="p-4" sx={{ borderRadius: '15px', backgroundColor: '#ffffff' }}>
                <Typography variant="h3" gutterBottom align="center" sx={{ fontWeight: 'bold', color: 'rgb(12, 12, 95)',fontFamily: 'Roboto Slab, serif' }}>
                    About Holy Institute
                </Typography>
                <Typography variant="body1" align="center" paragraph sx={{ color: '#34495e',fontFamily: 'Roboto Slab, serif' }}>
                    Holy Institute offers German language courses with various levels, including A1, A2, B1, and B2. Each course lasts 2 months, with fees ranging from 10,000 INR to 18,000 INR. We provide flexible class timings including morning, evening, and weekend sessions. Both online and offline coaching options are available. We offer low fees, hostel accommodation, and free counseling with the support of our German office. We also assist with exam slots for Goethe, Telc, ÖSD, and ELC exams.
                </Typography>
                <Typography variant="body1" align="center" sx={{ color: '#34495e',fontFamily: 'Roboto Slab, serif' }}>
                    Join us at Holy Institute and take advantage of our comprehensive and affordable German language courses designed to help you achieve fluency and succeed in your language proficiency exams.
                </Typography>
            
                <Typography variant="h5" gutterBottom align="center" className='mt-5 text-secondary' sx={{ fontWeight: 'bold',fontFamily: 'Roboto Slab, serif' }}>
                    Contact Information
                </Typography>
                <Row className="justify-content-center">
                    <Col xs={12} md={4} className="text-center">
                        <PhoneIcon sx={{ fontSize: 40, color: '#2980b9' }} />
                        <Typography variant="h6" sx={{ color: '#34495e', fontWeight: 'bold',fontFamily: 'Roboto Slab, serif' }}>
                            Phone
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#34495e',fontFamily: 'Roboto Slab, serif' }}>
                            +91 9847929359
                        </Typography>
                    </Col>
                    <Col xs={12} md={4} className="text-center">
                        <LocationOnIcon sx={{ fontSize: 40, color: '#2980b9' }} />
                        <Typography variant="h6" sx={{ color: '#34495e', fontWeight: 'bold',fontFamily: 'Roboto Slab, serif' }}>
                            Address
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#34495e',fontFamily: 'Roboto Slab, serif' }}>
                            Room No:35, Lamex Arcade, Post Office Rd, Kuruppam, Thekkinkadu Maidan, Thrissur, Kerala 680001
                        </Typography>
                    </Col>
                    <Col xs={12} md={4} className="text-center">
                        <EmailIcon sx={{ fontSize: 40, color: '#2980b9' }} />
                        <Typography variant="h6" sx={{ color: '#34495e', fontWeight: 'bold',fontFamily: 'Roboto Slab, serif' }}>
                            Email
                        </Typography>
                        <Typography variant="body1">
                            <a href="mailto:holyinstitutionstcr@gmail.com" style={{ textDecoration: 'none', color: '#2980b9',fontFamily: 'Roboto Slab, serif' }}>
                                holyinstitutionstcr@gmail.com
                            </a>
                        </Typography>
                    </Col>
                </Row>
            </Box>

        </Container>
    );
};

export default About;
